import CHECKOUT_CONST from '@/constants/Checkout';
import { getYear } from 'date-fns';

export default {
  state: {
    isLoading: false,
    currentStep: 1,
    stepValidation: {
      step1: false,
      step2: true,
      step3: false,
      step4: false,
      step5: true,
    },
    plan: {},
    planData: {},
    liabilityPercentage: CHECKOUT_CONST.DEFAULT.LIABILITY_PERCENTAGE,
    selectedStates: [],
    coverageArea: {
      region: {},
      state: {},
      liabilityYear: getYear(new Date()) - 1,
    },
    materials: [],
    leadForm: {},
    paymentForm: {},
    termUse: false,
    organization: {
      organization: {},
    },
    orderStatus: {
      subscription: {
        start_dateFormatted: '',
      },
    },
    // Campos e Formulários da Etapa 5 (Cadastro da Empresa)
    organizationRepresentantForm: {},
    associationList: [],
    companyForm: {},
    companyBranchesForm: {},
    companyBranches: [],
    companyBranchEdit: null,
    // Checkbox de Alerta Mato Grosso do Sul
    checkboxAware: false,
    // Exibição da modal na página inicial
    // modalLanding: true,
    leadContactEnableRever: false,
  },
  mutations: {
    // Exibição da modal na página inicial
    // setModalLanding(state, status) {
    //   state.modalLanding = status;
    // },
    setTermUse(state, status) {
      state.termUse = status;
      // state.stepValidation.step6 = state.termUse && state.validPaymentForm;
    },
    setIsLoading(state, data) {
      state.isLoading = data;
    },
    planData(state, data) {
      state.planData = data;
      state.plan = state.planData.prices[state.liabilityPercentage];
    },
    changeLiabilityPercentage(state, percentage) {
      state.liabilityPercentage = percentage;
      state.plan = state.planData.prices[state.liabilityPercentage];
      // state.stepValidation.step1 = true;
    },
    // Altera a região selecionado pelo usuário na etapa 4
    changeRegion(state, region) {
      state.coverageArea.region = region;
      state.coverageArea.state = null;

      state.stepValidation.step4 = true;
      state.checkboxAware = false;
    },
    // Altera o estado selecionado pelo usuário na etapa 4
    changeState(state, st) {
      state.coverageArea.state = st;

      state.stepValidation.step4 = true;
      state.checkboxAware = false;

      // Reseto o campo
      state.coverageArea.liabilityYear = getYear(new Date()) - 1;

      // Validação para o estado do Rio de Janeiro
      if (state.coverageArea.state.code === 'RJ') {
        state.stepValidation.step4 = false;
      }

      // Validação para o estado do MS
      if (state.coverageArea.state.code === 'MS') {
        state.stepValidation.step4 = false;
      }
    },
    changeStates(state, states) {
      state.selectedStates = states;
    },
    // Altera o ano de compensação
    setLiabilityYear(state, year) {
      state.stepValidation.step4 = false;

      // Validação para o estado do MS
      if (state.coverageArea.state.code === 'MS' && year) {
        state.coverageArea.liabilityYear = year;
        state.stepValidation.step4 = true;
      }
    },
    // Altera o valor do Checkbox do na etapa 4
    setCheckboxAware(state, data) {
      state.checkboxAware = data;

      if (state.selectedStates.find(estado => estado.id === 'BR-RJ') == null) {
        state.stepValidation.step4 = true;
        return;
      }

      // Validação para o estado do Rio de Janeiro
      if (
        state.selectedStates.find(estado => estado.id === 'BR-RJ') != null &&
        state.checkboxAware
      ) {
        state.stepValidation.step4 = true;
      } else {
        state.stepValidation.step4 = false;
      }
    },
    changeMaterials(state, material) {
      state.materials = material;
      state.stepValidation.step3 = !!state.materials.filter(el => el.selected)
        .length;
    },
    changeStep(state, data) {
      state.currentStep = data ? state.currentStep + 1 : state.currentStep - 1;
    },
    validateStep1(state, status) {
      state.stepValidation.step1 = status;
    },
    // validateStep6(state) {
    //   state.stepValidation.step6 = state.termUse && state.validPaymentForm;
    // },
    // validPaymentForm(state, status) {
    //   state.validPaymentForm = status;
    //   state.stepValidation.step6 = state.termUse && state.validPaymentForm;
    // },
    organization(state, form) {
      state.organization = form;
    },
    leadForm(state, form) {
      state.leadForm = form;
    },
    paymentForm(state, form) {
      state.paymentForm = form;
    },
    clientForm(state, obj) {
      state.companyForm = obj.companyForm;
      state.organizationRepresentantForm = obj.organizationRepresentantForm;
    },
    orderStatus(state, obj) {
      state.orderStatus = obj;
    },
    setCompanyBranches(state, obj) {
      state.companyBranches = obj;
    },
    setCompanyBranchEdit(state, obj) {
      state.companyBranchEdit = obj;
    },
    setAssociationList(state, obj) {
      state.associationList = obj;
    },
    leadContactEnableRever(state, obj) {
      state.leadContactEnableRever = obj;
    },
  },
  getters: {
    // Exibição da modal na página inicial
    // getModalLanding(state) {
    //   return state.modalLanding;
    // },
    containRJ(state) {
      if (state.selectedStates.find(estado => estado.id === 'BR-RJ')) {
        return true;
      }
      return false;
    },
    containMS(state) {
      if (state.selectedStates.find(estado => estado.id === 'BR-MS')) {
        return true;
      }
      return false;
    },
    getStates(state) {
      return state.selectedStates;
    },
    getTermUse(state) {
      return state.termUse;
    },
    getIsLoading(state) {
      return state.isLoading;
    },
    planData(state) {
      return state.planData;
    },
    liabilityPercentage(state) {
      return state.liabilityPercentage;
    },
    getSelectedPlan(state) {
      return state.planData.prices[state.liabilityPercentage];
    },
    regionCoverage(state) {
      return state.coverageArea;
    },
    materials(state) {
      return state.materials;
    },
    getCurrentValidation(state) {
      return state.currentStep;
    },
    getStepValidation(state) {
      return state.stepValidation;
    },
    getValidPaymentForm(state) {
      return state.validPaymentForm;
    },
    getOrganization(state) {
      return state.organization;
    },
    getOrderStatus(state) {
      return state.orderStatus;
    },
    getLeadForm(state) {
      return state.leadForm;
    },
    getPaymentForm(state) {
      return state.paymentForm;
    },
    getCompanyForm(state) {
      return state.companyForm;
    },
    getOrganizationRepresentantForm(state) {
      return state.organizationRepresentantForm;
    },
    // Retorna o valor do Checkbox do Mato Grosso do Sul na etapa 2
    checkboxAware(state) {
      return state.checkboxAware;
    },
    getCompanyBranches(state) {
      return state.companyBranches;
    },
    getCompanyBranchEdit(state) {
      return state.companyBranchEdit;
    },
    getAssociationList(state) {
      return state.associationList;
    },
  },
};
